import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useTheme, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Translator from 'translator';

function addFileModal({ onClose, classes, onUpload, onFileChange, isFileSelected }) {
    const theme = useTheme();

    return (
        <Dialog open onClose={onClose} maxWidth={false}>
            <DialogTitle>
                <Typography style={{ fontSize: 20 }} color="primary">
                    {Translator.translate('generic.files.modal.title')}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ margin: '20px 0' }}>
                <input type="file" onChange={onFileChange} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{Translator.translate('general.cancel')}</Button>
                <Button disabled={!isFileSelected} variant="contained" color="primary" onClick={onUpload}>
                    {Translator.translate('general.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const styles = theme => ({
    container: {
        width: '90vw',
        padding: 18,
    },
    title: {
        color: theme.palette.primary.main,
        fontSize: 34,
        fontWeight: 400,
        marginBottom: 12,
    },
    icon: {
        fontSize: '2rem',
        marginRight: 8,
    },
    subtitle: {
        color: theme.palette.primary.main,
        fontSize: 18,
    },
});

addFileModal.propTypes = {
    isFileSelected: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    onFileChange: PropTypes.func.isRequired,
};
addFileModal.defaultProps = {};

export default withRouter(
    connect(
        null,
        dispatch => bindActionCreators({}, dispatch),
    )(withStyles(styles, { withTheme: true })(addFileModal)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/components/FileManager/AddFileModal.js